import axios from 'axios';
import { API_URL } from '../../config/config';

export default class DomainService {
    static instance() {
        if (this._instance) {
            return this._instance;
        }
        return this._instance = new DomainService();
    }

    getDomainConfig() {
        return axios.get(API_URL + "/public/domain/config", { headers: {"x-window-hostname": window.location.hostname} });
    }

}
